import React from 'react';
import classnames from 'classnames';

//TODO: позже настроить для плагина
// import { graphql, useStaticQuery } from "gatsby";
// import { GatsbyImage, getImage } from "gatsby-plugin-image";

import useIntersection from 'hooks/useIntersection';
import * as styles from './hero.module.scss';
import 'styles/common/_hero.scss';
import 'styles/framework/_common.scss';

const Hero = ({ data }) => {
  const { scrollWrapper, inViewSec, inViewRefSec } = useIntersection({
    threshold: 0.6,
  });

  return (
    <div ref={scrollWrapper}>
      <section
        className={classnames(styles.section, 'cr-hero-sec cr-dark-blue-bg')}
        ref={inViewRefSec}
      >
        <div className="cr-wrap">
          <div
            className={classnames(
              styles.content,
              'cr-content',
              inViewSec && 'jsAnimInit'
            )}
          >
            <p
              className={classnames(
                'cr-page-name cr-subheader cr-text-3 cr-opacity-05'
              )}
            >
              {data.page_name && data.page_name}
            </p>

            <h1 className={classnames(styles.title, 'cr-h1 cr-white')}>
              {data.title} &#160;
              <span className={classnames('cr-title-extra')}>
                {data.marked_title && data.marked_title}
              </span>
            </h1>

            <p
              className={classnames(
                styles.description,
                'cr-description cr-lead cr-white'
              )}
            >
              {data.description && data.description}
            </p>
          </div>
        </div>

        <div className={classnames(styles.media)}>
          {data.media && <img src={data.media} alt="" />}
        </div>
        {/* TODO: позже настроить для плагина */}
        {/* <GatsbyImage image={HeroImage} alt="" /> */}
      </section>
    </div>
  );
};

export default Hero;
